// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1vFnc","checkboxCol":"Table_checkboxCol__3j31e","emailCol":"Table_emailCol__13Ccd","actionCol":"Table_actionCol__1laQW"};